module.exports = __webpack_public_path__ + "img/banner-fr.1aa3b386.png";